// Focus handling shared by the queue's modals: on mount, remember what opened the
// modal and move focus to `fieldRef`; on unmount, give focus back to the opener if
// it is still on the page. The opener is read BEFORE focusing the field, or it
// would be the field itself.

import { useEffect } from "react";

export default function useReturnFocus(fieldRef) {
  useEffect(() => {
    const opener = document.activeElement;
    fieldRef.current?.focus();
    return () => {
      if (
        opener &&
        typeof opener.focus === "function" &&
        document.contains(opener)
      ) {
        opener.focus();
      }
    };
    // A ref object never changes identity, so this runs on mount and unmount only.
  }, [fieldRef]);
}
